import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { API_QUERY_KEYS, getConsultation, QueryDefaults } from 'api';
import { Consultation } from 'types';

export const useConsultation = (id: number): UseQueryResult<Consultation, unknown> =>
  useQuery([API_QUERY_KEYS.getConsultation, id], () => getConsultation(id), QueryDefaults);
